module.exports = __webpack_public_path__ + "static/pic_service3-a1ca1fd2d3d05c58e1c76936d34b8efd.jpg";